import { cpf } from 'cpf-cnpj-validator';

const validateCpf = (number: string): boolean => cpf.isValid(number);

export default validateCpf;
